<template>
  <div>
    <router-link to="/" class="backbutton"
      ><i class="material-icons">arrow_back_ios</i></router-link
    >

    <div class="postcontainer">
      <div v-for="data in showdata" :key="data.title">
        <h1>{{ data.title }}</h1>
        <img
          :src="data.img1"
          :alt="data.title"
          class="image"
          v-if="data.img1"
        /><br />
        <p v-html="data.disc"></p>
        <img
          id="img2"
          :src="data.img2"
          :alt="data.title"
          class="image"
          v-if="data.img2"
        /><br />
        <p v-html="data.disc2" v-if="data.disc2"></p>
        <img
          id="img3"
          :src="data.img3"
          :alt="data.title"
          class="image"
          v-if="data.img3"
        /><br />
        <p v-html="data.disc3" v-if="data.disc3"></p>
        <h4>@ck stocks&amp; personal finance</h4>

        <hr />
        <span id="auther"
          ><span style="font-weight: 100; font-size: 14px"> Artical By - </span>

          <a href="https://twitter.com/ichandragangani?s=09" target="_blank">{{
            data.auther
          }}</a></span
        ><br />
        {{ data.date.toDate().toString().substring(0, 25) }}
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import firebase from "firebase";
import firebaseApp from "../firebaseInit";
var db = firebaseApp.firestore();
export default {
  name: "post",
  data() {
    return {
      title: this.$route.params.title,
      showdata: [],
    };
  },

  mounted() {
    Vue.$toast.open({
      message: "Loading...",
      type: "info",
      position: "bottom-left",
    });
    this.showabledata();
  },
  methods: {
    showabledata() {
      db.collection("posts")
        .where(firebase.firestore.FieldPath.documentId(), "==", this.title)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.showdata.push({
              id: doc.id,
              title: doc.data().title,
              disc: doc.data().disc,
              disc2: doc.data().disc2,
              disc3: doc.data().disc3,
              auther: doc.data().auther,
              date: doc.data().date,
              img1: doc.data().img,
              img2: doc.data().img2,
              img3: doc.data().img3,
            });
            window.document.title = this.showdata[0].title + " - Ckstocks";
          });
        });
    },
  },
};
</script>
        
<style scoped>
.postcontainer {
  display: grid;
  line-height: 1.2;
  border: 0.5px solid rgba(0, 0, 0, 0.356);
  margin-top: 50px;
  justify-items: center;
  width: 80%;
  margin-left: 50%;
  transform: translate(-50%, 0%);
  padding: 0px 25px 10px 25px;
  overflow-wrap: anywhere;
  margin-bottom: 35px;
  border-radius: 4px;
}
#img2 {
  width: 80%;
  margin-left: 10% !important;
}
#img3 {
  width: 80%;
  margin-left: 10% !important;
}
.image {
  margin-left: 20%;
  max-width: 100%;
  height: auto;
  width: 60%;
  max-height: 80vh;
}
.backbutton {
  position: fixed;
  z-index: 999;
  padding: 5px;
  margin-left: 1%;
  margin-top: 1rem;
  transition: 0.4s;
}
#auther {
  font-size: 18px;
  text-transform: capitalize;
  font-weight: 600;
}
</style>

